import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, DateInput } from '../../Form';
import moment from 'moment';
import {dataDelivery as api} from '../../../actions/api';

@inject('dataExportStore', 'stationStore', 'parameterStore')
@observer
class DataExportAdd extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug = `/export/data-export`;
  title = 'Add Data Export';

  @observable date_from = moment().format('YYYY-MM-DDT00:00:00');
  @observable date_to = moment().add(1, 'days').format('YYYY-MM-DDT00:00:00');
  @observable isRunning = false;

  onChangeDateFrom = e => this.date_from = e.target.value;
  onChangeDateTo = e => this.date_to = e.target.value;

  handleRun = e => {
    e.preventDefault();
    const {notify} = this.context;

    this.isRunning = true;
    api.export.run(this.props.params.id, this.date_from, this.date_to)
      .then(res => {
        this.isRunning = false;
        notify.success(res);
      })
      .catch(err => {
        this.isRunning = false;
        notify.error(err);
      })
  }

  render() {
    const { dataExportStore, params: {id} } = this.props;
    let dataExport = dataExportStore.findById(id);
    console.log(moment(''))
    return (
      <Modal title={`Run export: ${dataExport.name}`} slug={this.slug} isSaving={this.isRunning} >
        <Form>
          <FormBody>
            <DateInput type='datetime-local' label='Date From' value={this.date_from} onChange={this.onChangeDateFrom}/>
            <DateInput type='datetime-local' label='Date To' value={this.date_to} onChange={this.onChangeDateTo}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleRun}>Run</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default DataExportAdd;




// WEBPACK FOOTER //
// ./src/components/DataDelivery/DataExport/DataExportRun.js